import { AdditionalData, EventProduct, MetricsEvent } from "./metrics";

export const sendToGoogleTagManager = (event: MetricsEvent) => {
  if (typeof window === "undefined") return;

  const gtmDataLayer = (window as any).dataLayer || [];

  gtmDataLayer.push({ ecommerce: null });

  switch (event.type) {
    case "view_item_list": {
      const payload = event.data;

      gtmDataLayer.push({
        event: "view_item_list",
        ecommerce: {
          items: transformProducts(payload.products, {
            from: payload?.from ?? "List View",
          }),
        },
      });
      break;
    }
    
    case "view_item": {
      const payload = event.data;
      
      gtmDataLayer.push({
        event: "view_item",
        ecommerce: {
          items: transformProducts([payload.product], {
            from: payload?.from ?? "Item View",
          }),
        },
      });
      break;
    }
      
    case "add_to_cart": {
      const payload = event.data;

      gtmDataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          items: transformProducts([payload.product], {
            from: payload?.from ?? "Item View",
          }),
        },
      });
      break;
    }

    case "remove_from_cart": {
      const payload = event.data;

      gtmDataLayer.push({
        event: "remove_from_cart",
        ecommerce: {
          items: transformProducts([payload.product], {
            from: payload?.from ?? "Cart",
          }),
        },
      });
      break;
    }

    case "add_to_favorites": {
      const payload = event.data;

      gtmDataLayer.push({
        event: "add_to_wishlist",
        ecommerce: {
          items: transformProducts([payload.product], {
            from: payload?.from ?? "List View",
          }),
        },
      });
      break;
    }

    case "remove_from_favorites": {
      const payload = event.data;

      gtmDataLayer.push({
        event: "remove_from_wishlist",
        ecommerce: {
          items: transformProducts([payload.product], { from: "Favorites" }),
        },
      });
      break;
    }

    case "order_status_check": {
      gtmDataLayer.push({
        event: "order_status_check",
      });
      break;
    }
      
    case "begin_checkout": {
      const payload = event.data;

      gtmDataLayer.push({
        event: "begin_checkout",
        ecommerce: {
          userId: payload?.userId,
          total: payload.total,
          items: transformProducts(payload.products, {
            from: "Cart",
          }),
        },
      });
      break;
    }
      
    case "add_shipping_info": {
      const payload = event.data;

      gtmDataLayer.push({
        event: "add_shipping_info",
        ecommerce: {
          shipping_tier: payload.shippingMethod,
          items: transformProducts(payload.products, {
            from: "Cart",
          }),
        },
      });
      break;
    }
      
    case "add_payment_info": {
      const payload = event.data;
      
      gtmDataLayer.push({
        event: "add_payment_info",
        ecommerce: {
          payment_type: payload.paymentMethod,
          items: transformProducts(payload.products, {
            from: "Cart",
          }),
        },
      });
      break;
    }
      
    case "purchase": {
      const payload = event.data;
      
      gtmDataLayer.push({
        event: "purchase",
        ecommerce: {
          transaction_id: payload?.orderId,
          value: payload?.value,
          tax: payload?.tax,
          shipping: payload?.shipping,
          currency: "KZT",
          items: payload.products ? transformProducts(payload.products, {
            from: "Cart",
          }) : [],
        },
      });
      break;
    }
    
    case "repeat_purchase": {
      const payload = event.data;
      
      gtmDataLayer.push({
        event: "repeat_purchase",
        ecommerce: {
          user_id: payload.userId,
        },
      });
      break;
    }
      
    case "return_initiated": {
      const payload = event.data;
      
      gtmDataLayer.push({
        event: "return_initiated",
        ecommerce: {
          order_id: payload.orderId,
        },
      });
      break;
    }
      
    case "kaspi_pay_success": {
      const payload = event.data;
      
      gtmDataLayer.push({
        event: "kaspi_pay_success",
        ecommerce: {
          order_id: payload.orderId,
        },
      });
      break;
    }
      
    case "kaspi_pay_failed": {
      const payload = event.data;
      
      gtmDataLayer.push({
        event: "kaspi_pay_failed",
        ecommerce: {
          order_id: payload.orderId,
        },
      });
      break;
    }
  }
};

const transformProducts = (
  products: EventProduct[],
  additionalData?: AdditionalData,
) => {
  return products.map((product, index) => ({
    index,
    item_id: product.id,
    item_name: product.name,
    item_category: product?.category?.name ?? "Продукт",
    item_brand: "Qazaq Republic",
    price: product?.price ?? 0,
    quantity: product?.quantity ?? 1,
    ...(additionalData
      ? {
          item_list_item: additionalData.from,
        }
      : {}),
  }));
};
